import { jsx as _jsx } from "react/jsx-runtime";
var PadLock1 = function PadLock1(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size * 1.23076923077,
    viewBox: "0 0 13 16",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7095 5.33333H9.95947V3.80952C9.95947 1.67619 8.30947 0 6.20947 0C4.10947 0 2.45947 1.67619 2.45947 3.80952V5.33333H1.70947C0.884473 5.33333 0.209473 6.01905 0.209473 6.85714V14.4762C0.209473 15.3143 0.884473 16 1.70947 16H10.7095C11.5345 16 12.2095 15.3143 12.2095 14.4762V6.85714C12.2095 6.01905 11.5345 5.33333 10.7095 5.33333ZM3.88447 3.80952C3.88447 2.51429 4.93447 1.44762 6.20947 1.44762C7.48447 1.44762 8.53447 2.51429 8.53447 3.80952V5.33333H3.88447V3.80952Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default PadLock1;